import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'primeng/api';
import { AdicionalEDesconto } from 'src/app/admihair/api/dto/adicional-e-desconto';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { PlanoContaEmpresa } from 'src/app/admihair/api/dto/plano-conta-empresa.';
import { Profissional } from 'src/app/admihair/api/dto/profissional';
import { AdicionalEDescontoService } from 'src/app/admihair/service/adicional-e-desconto.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { PlanoContaEmpresaService } from 'src/app/admihair/service/plano-conta-empresa.service';
import { ProfissionalService } from 'src/app/admihair/service/profissional.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-adicionais-e-descontos-editar',
  templateUrl: './adicionais-e-descontos-editar.component.html',
  styleUrls: ['./adicionais-e-descontos-editar.component.scss']
})
export class AdicionaisEDescontosEditarComponent implements OnInit {

  permissaoEditar: boolean = false;
  loading: boolean = true;
  messages: Message[] = [];
  messagemVisivel: boolean = false;
  progressoRequisicao: boolean = false;
  id?: number
  empresaSelecionada?: Empresa;
  adicionalEDesconto?: AdicionalEDesconto;
  profissionais: Profissional[] = [];
  contas: PlanoContaEmpresa[] = [];
  registro: Date = new Date();
  competencia: Date = new Date();

  constructor(private adicionalEDescontoService: AdicionalEDescontoService,
    private planoContaEmpresaService: PlanoContaEmpresaService,
    private profissionalService: ProfissionalService,
    private utilStorageService: UtilStorageService,
    private _activatedRoute: ActivatedRoute,
    private erroService: ErroService) { }

  ngOnInit(): void {
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_ADICIONAIS_E_DESCONTOS');
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
    this.carregarId();
    if (this.permissaoEditar) {
      this.carregarProfissionais();
    }
  }

  atualizar(){
    this.progressoRequisicao = true;
    if(this.adicionalEDesconto){
      this.adicionalEDesconto.operador = this.utilStorageService.getUser().usuario.id;
      this.adicionalEDescontoService.atualizar(this.adicionalEDesconto).subscribe({
        next: (data: AdicionalEDesconto) => {
          this.progressoRequisicao = false;
          this.messages = this.erroService.handleSuccess();
          this.messagemVisivel = true;
          this.rolarTela();
          this.carregarAdicionalDesconto();
        },
        error: (err: any) => {
          this.progressoRequisicao = false;
          this.messages = this.erroService.handleErro(err);
          this.messagemVisivel = true;
          this.rolarTela();
          this.carregarAdicionalDesconto();
        }
      });
    }
    
  }

  carregarAdicionalDesconto(){
    this.adicionalEDescontoService.buscarPorId(this.id).subscribe({
      next: (data: AdicionalEDesconto) => {
        this.adicionalEDesconto = data;
        if(data.dataRegistro){
          this.adicionalEDesconto.dataRegistro = new Date(data.dataRegistro + 'T05:00:00Z');
        }
        if(data.dataCompetencia){
          this.adicionalEDesconto.dataCompetencia = new Date(data.dataCompetencia + 'T05:00:00Z');
        }
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    })
  }

  carregarProfissionais(){
    this.profissionalService.listarAtivosPorEmpresaId(this.empresaSelecionada?.id).subscribe({
      next: (data: Profissional[]) => {
        this.profissionais = data;
        this.carregarContas();
      },
      error: (err: any) => {
        this.loading = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    })
  }

  carregarContas(){
    const grupoId = 3;
    const utilizacoes = ['FOLHA DE PAGAMENTO', 'FOLHA/DESPESA'];
    this.planoContaEmpresaService.listarPorEmpresaGrupoEUtilizacao(this.empresaSelecionada?.id, 3, utilizacoes).subscribe({
      next: (data: PlanoContaEmpresa[]) => {
        this.contas = data;
        this.carregarAdicionalDesconto();
      },
      error: (err: any) => {
        this.loading = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    })
  }

  carregarId(){
    const idParam = this._activatedRoute.snapshot.paramMap.get('id');
    if(idParam){
      this.id = parseInt(idParam);
    }
  }


  verificarPermissao(nome: string): boolean{
    return AuthUtil.verificarPermissao(nome);
  }

  rolarTela(){
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

}
